import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Cloud } from "../../../Assets/img/Kyc/svg/Cloud.svg";
import { ReactComponent as Takephoto } from "../../../Assets/img/Kyc/svg/Takephoto.svg";
import { Button, Dialog, InputAdornment, TextField } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import { ReactComponent as Successmsg } from "../../../Assets/img/Kyc/svg/successmsg.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Verify } from "../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as NonVerify } from "../../../Assets/img/icons/Verified-icon-new.svg";
import "../../../Assets/css/kyc.css";

const VerifyPassport = () => {
  const navigate = useNavigate();
  const numOfContainers = 6;
  const [verify, setVerify] = useState(false);
  const [open, setOpen] = useState(false);
  const [mrzCode, setMrzCode] = useState("");
  const [givenNumber, setGivenNumber] = useState("");
  const [passPortNumber, setPassPortNumber] = useState("");
  const [surName, setSurName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [birthPlace, setBirthPlace] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verifiedOpen, setVerifiedOpen] = useState(false);
  const [showData, setShowData] = useState(true);
  const [masking, setMasking] = useState();
  const [para1, setPara1] = useState(true);
  const [para2, setPara2] = useState(true);
  const inputRefs = useRef([]); // Create an array of refs for each text field

  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const maskingFunction = (number) => {
    if (number.length <= 4) {
      return number; // If the number is less than or equal to 4 digits, don't mask it
    }
    return number.slice(-4).padStart(number.length, "*");
  };

  const handleMasking = (e) => {
    const inputValue = e.target.value;
    setPassPortNumber(inputValue);
    const maskedValue = maskingFunction(inputValue);
    setMasking(maskedValue);
  };

  const handleValidation = () => {
    if (!validateSurname(surName)) {
      alert("Surname should only contain alphabetic characters.");
      return;
    }
    setOpen(true);
  };

  const validateSurname = (surname) => {
    const expression = /^[A-Za-z]+$/;
    return expression.test(surname); // Returns true if valid, false otherwise
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    // Validate input: check if it's a number
    if (/^\d$/.test(value)) {
      // If valid, move focus to the next field
      if (index < numOfContainers - 1) {
        inputRefs.current[index + 1].focus();
      }
    } else {
      // If not valid, clear the input
      e.target.value = "";
    }
  };

  const handleClose = () => {
    setOpen(false);
    setShowData(false);
    setVerifiedOpen(false);
  };

  const [files, setFiles] = useState([]); // Track multiple files (up to 3)
  const maxFiles = 3;

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files); // Convert to an array
    const updatedFiles = [...files, ...selectedFiles].slice(0, maxFiles); // Limit to 3 files

    setFiles(updatedFiles); // Update state with new files
  };

  const handleFileRemove = (indexToRemove) => {
    const updatedFiles = files.filter((_, index) => index !== indexToRemove);
    setFiles(updatedFiles); // Remove selected file
  };
  useEffect(() => {
    // Set para1 to false when index is 1
    if (files.length > 1) {
      setPara1(false);
    }
    if (files.length > 2) {
      setPara2(false);
    }
  }, [files]);

  return (
    <>
      <div className="Allcards_full_container p-3">
        <div className=" rounded-2 bg-white p-2">
          <div className=" d-flex flex-column align-items-center justify-content-center m-4">
            <h2 className="m-0">Verify Your Passport Identity</h2>
            {showData ? (
              <p className="paragraph m-0">
                Upload Your Passport for Secure Verification
              </p>
            ) : (
              <p className="paragraph m-0">
                Your Passport has been Verified Successfully.
              </p>
            )}

            <div className="d-flex flex-column align-items-center justify-content-center">
              <div className="file-preview">
                {files.map((file, index) => (
                  <div key={index} className="selectedImage m-2">
                    {file.type.startsWith("image/") ? (
                      <>
                        <img
                          src={URL.createObjectURL(file)}
                          alt={`Selected ${index}`}
                          style={{
                            // maxWidth: "200px",
                            // maxHeight: "200px",
                            width: "100px",
                            height: "100px",
                            objectFit: "fill",
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <iframe
                          src={URL.createObjectURL(file)}
                          title={`Selected PDF ${index}`}
                          style={{
                            width: "200px",
                            height: "200px",
                          }}
                        />
                      </>
                    )}
                  </div>
                ))}
              </div>

              {files.map((file, index) => (
                <div key={index}>
                  {index === 0 && (
                    <div>
                      {para1 && (
                        <p>
                          Upload Your Back page of Passport for Secure
                          Verification
                        </p>
                      )}
                    </div>
                  )}
                  {index === 1 && (
                    <div>
                      {para2 && (
                        <p>Upload Your Barcode for Secure Verification</p>
                      )}
                    </div>
                  )}
                </div>
              ))}

              <div className="flex-row d-flex">
                {files.length < maxFiles && (
                  <>
                    <input
                      type="file"
                      accept="image/*,.pdf" // Accept images and PDF files
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      id="file-input"
                      multiple // Allow selecting multiple files
                    />

                    <label
                      htmlFor="file-input"
                      className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3"
                    >
                      <Cloud width={80} />
                      <span className="m-0 p-0">
                        Drag file here or{" "}
                        <span className="text-primary">Upload File</span>
                      </span>
                      <p>5MB max file size</p>
                    </label>
                  </>
                )}

                {files.length < maxFiles && (
                  <Button className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3">
                    <Takephoto />
                    <p className="custom-text-color text-capitalize">
                      Capture Image
                    </p>
                  </Button>
                )}
              </div>
            </div>

            {showData ? (
              <p className="paragraph">
                Please upload clear images of both the front and back pages of
                your passport, along with the barcode, to begin the verification
                process.
                <br />
                Our system will automatically detect and display your passport
                details. Alternatively, you can manually enter the details
                below.
              </p>
            ) : (
              ""
            )}
            {!showData && (
              <div className="d-flex flex-row align-items-center">
                <TextField
                  value={masking}
                  label={"Passport Number*"}
                  className="m-4"
                  style={{ width: "400px" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {verify ? <Verify /> : <NonVerify />}
                      </InputAdornment>
                    ),
                  }}
                />

                {/* <div className="verify d-flex align-items-center">
              {verify ? <Verify /> : <NonVerify />}
            </div> */}
              </div>
            )}

            {!showData ? (
              <p className="paragraph">
                Thank You for Verifying Your Passport. Your identity has been
                securely confirmed. You can now proceed to the <br />
                next steps or return to your dashboard to explore other
                features.
              </p>
            ) : (
              ""
            )}

            {showData ? (
              <>
                <TextField
                  inputRef={inputRef}
                  value={mrzCode}
                  onChange={(e) => setMrzCode(e.target.value)}
                  label={"MRZ Code*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />
                <TextField
                  value={passPortNumber}
                  onChange={handleMasking}
                  label={"Passport Number*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />

                <TextField
                  value={givenNumber}
                  onChange={(e) => setGivenNumber(e.target.value)}
                  label={"Given Number"}
                  className="m-2"
                  style={{ width: "400px" }}
                />

                <TextField
                  value={surName}
                  onChange={(e) => setSurName(e.target.value)}
                  label={"Surname"}
                  className="m-2"
                  style={{ width: "400px" }}
                />

                <TextField
                  type="date"
                  label={"Date of Birth"}
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                  className="m-2"
                  style={{ width: "400px" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />

                <TextField
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  label={"Gender*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />

                <TextField
                  value={birthPlace}
                  onChange={(e) => setBirthPlace(e.target.value)}
                  label={"Place of Birth*"}
                  className="m-2"
                  style={{ width: "400px" }}
                />

                <TextField
                  type="date"
                  label={"Date of Issue"}
                  value={issueDate}
                  onChange={(e) => setIssueDate(e.target.value)}
                  className="m-2"
                  style={{ width: "400px" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />

                <TextField
                  type="date"
                  value={expiryDate}
                  label={"Date of Expiry"}
                  onChange={(e) => setExpiryDate(e.target.value)}
                  className="m-2"
                  style={{ width: "400px" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />

                <TextField
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  label={"Phone Number"}
                  className="m-2"
                  placeholder="
              +91"
                  style={{ width: "400px" }}
                  id="captchaInput"
                />
              </>
            ) : (
              ""
            )}

            {showData ? (
              <Button
                variant="contained"
                className=" btncolor m-3"
                onClick={() => handleValidation()}
              >
                Send Otp
              </Button>
            ) : (
              <Button
                variant="contained"
                className=" btncolor m-3 --bs-primary"
                onClick={() =>
                  navigate("/countrySelecting", {
                    state: {
                      SelectedCountry: {
                        label: "India",
                        code: "IN",
                        phone: "91",
                      },
                    }, // Pass the selected country object
                  })
                }
              >
                Back to KYC
              </Button>
            )}

            <Dialog open={open} onClose={() => setOpen(true)}>
              <div className="m-4 justify-content-center align-items-center">
                <div
                  className="d-flex flex-row justify-content-between align-items-center"
                  sx={{ margin: 2, padding: 0 }}
                >
                  <div>
                    <h6 className="m-0 p-0 fw-bold">Enter Your OTP</h6>
                  </div>

                  <div>
                    {/* <Close onClick={() => setOpen(false)} /> */}
                    <CloseRoundedIcon onClick={() => setOpen(false)} />
                  </div>
                </div>
                <div>
                  <div>
                    <p className="m-0 p-0">
                      Verify Your Passport with the One-Time Password
                    </p>

                    <div className="d-flex flex-row m-5">
                      {Array.from({ length: numOfContainers }, (_, index) => (
                        <TextField
                          key={index}
                          inputRef={(el) => (inputRefs.current[index] = el)} // Assign ref to each text field
                          variant="standard"
                          style={{
                            margin: "10px",
                            width: "40px",
                            textAlign: "center",
                          }}
                          inputProps={{
                            maxLength: 1, // Only allow one character
                            style: { textAlign: "center" }, // Center text
                          }}
                          onChange={(e) => handleInputChange(e, index)} // Handle input change
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="m-3 d-flex justify-content-end">
                <Button
                  className="btncolor"
                  variant="contained"
                  onClick={() => {
                    setVerifiedOpen(true);
                    setOpen(false);
                  }}
                >
                  Verify
                </Button>
              </div>
            </Dialog>

            <Dialog open={verifiedOpen} onClose={() => setVerifiedOpen(false)}>
              <div className=" mx-5 my-2 p-2 align-items-center justify-content-center text-center">
                <Successmsg />
                <div className="align-items-center justify-content-center text-center">
                  <h6 className="fw-bold">Verification Successful!</h6>
                  <p>Your Passport Details has been successfully verified.</p>
                </div>
                {/* <DialogContentText></DialogContentText> */}
              </div>
              <div className=" d-flex justify-content-center my-4">
                <Button
                  variant="contained"
                  className="btncolor"
                  onClick={() => handleClose()}
                >
                  continue
                </Button>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
};

// const VerifyPassport = () => {
//   const navigate = useNavigate();
//   const numOfContainers = 6; // Constant for OTP input boxes
//   const maxFiles = 3; // Constant for maximum file uploads
//   const [verify, setVerify] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [mrzCode, setMrzCode] = useState("");
//   const [givenNumber, setGivenNumber] = useState("");
//   const [passPortNumber, setPassPortNumber] = useState("");
//   const [surName, setSurName] = useState("");
//   const [dob, setDob] = useState("");
//   const [gender, setGender] = useState("");
//   const [birthPlace, setBirthPlace] = useState("");
//   const [issueDate, setIssueDate] = useState("");
//   const [expiryDate, setExpiryDate] = useState("");
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [verifiedOpen, setVerifiedOpen] = useState(false);
//   const [showData, setShowData] = useState(true);
//   const [masking, setMasking] = useState("");
//   const [para1, setPara1] = useState(true);
//   const [para2, setPara2] = useState(true);
//   const inputRefs = useRef([]);
//   const inputRef = useRef(null);
//   const [files, setFiles] = useState([]);

//   const handleValidation = () => {
//     if (!validateSurname(surName)) {
//       alert("Surname should only contain alphabetic characters.");
//       return;
//     }
//     setOpen(true);
//   };

//   const validateSurname = (surname) => {
//     const expression = /^[A-Za-z]+$/;
//     return expression.test(surname); // Returns true if valid, false otherwise
//   };

//   const maskingFunction = (number) => {
//     if (number.length <= 4) {
//       return number; // Don't mask if number has 4 or fewer digits
//     }
//     return number.slice(-4).padStart(number.length, "*");
//   };

//   const handleMasking = (e) => {
//     const inputValue = e.target.value;
//     setPassPortNumber(inputValue);
//     const maskedValue = maskingFunction(inputValue);
//     setMasking(maskedValue);
//   };

//   const handleInputChange = (e, index) => {
//     const value = e.target.value;
//     if (/^\d$/.test(value)) {
//       // Move to next field if input is valid
//       if (index < numOfContainers - 1) {
//         inputRefs.current[index + 1].focus();
//       }
//     } else {
//       e.target.value = ""; // Clear input if invalid
//     }
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setShowData(false);
//     setVerifiedOpen(false);
//   };

//   const handleFileChange = (event) => {
//     const selectedFiles = Array.from(event.target.files);
//     const updatedFiles = [...files, ...selectedFiles].slice(0, maxFiles);
//     setFiles(updatedFiles);
//   };

//   const handleFileRemove = (indexToRemove) => {
//     const updatedFiles = files.filter((_, index) => index !== indexToRemove);
//     setFiles(updatedFiles);
//   };

//   useEffect(() => {
//     if (files.length > 1) {
//       setPara1(false);
//     }
//     if (files.length > 2) {
//       setPara2(false);
//     }
//   }, [files]);

//   return (
//     <>
//       <div className="d-flex flex-column align-items-center">
//         <h3>Verify Your Passport Identity</h3>
//         {showData ? (
//           <p>Upload Your Passport for Secure Verification</p>
//         ) : (
//           <p>Your Passport has been Verified Successfully.</p>
//         )}

//         {/* Passport Upload Section */}
//         <div className="file-preview">
//           {files.map((file, index) => (
//             <div key={index} className="selectedImage m-2">
//               {file.type.startsWith("image/") ? (
//                 <img
//                   src={URL.createObjectURL(file)}
//                   alt={`Selected ${index}`}
//                   style={{ maxWidth: "200px", maxHeight: "200px" }}
//                 />
//               ) : (
//                 <iframe
//                   src={URL.createObjectURL(file)}
//                   title={`Selected PDF ${index}`}
//                   style={{ width: "200px", height: "200px" }}
//                 />
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Form Fields */}
//         {showData && (
//           <>
//             <TextField
//               inputRef={inputRef}
//               value={mrzCode}
//               onChange={(e) => setMrzCode(e.target.value)}
//               label={"MRZ Code*"}
//               className="m-4"
//               style={{ width: "400px" }}
//             />
//             <TextField
//               value={passPortNumber}
//               onChange={handleMasking}
//               label={"Passport Number*"}
//               className="m-4"
//               style={{ width: "400px" }}
//             />
//             <TextField
//               value={surName}
//               onChange={(e) => setSurName(e.target.value)}
//               label={"Surname"}
//               className="m-4"
//               style={{ width: "400px" }}
//             />
//             {/* Additional Fields */}
//           </>
//         )}

//         {/* Buttons and Dialogs */}
//         {showData && (
//           <Button
//             variant="contained"
//             className="m-3"
//             onClick={handleValidation}
//           >
//             Send OTP
//           </Button>
//         )}
//       </div>

//       {/* OTP Dialog */}
//       <Dialog open={open} onClose={() => setOpen(false)}>
//         {/* OTP Dialog Content */}
//         <div className="m-4">
//           <h6>Enter Your OTP</h6>
//           <div className="d-flex flex-row m-5">
//             {Array.from({ length: numOfContainers }, (_, index) => (
//               <TextField
//                 key={index}
//                 inputRef={(el) => (inputRefs.current[index] = el)}
//                 variant="standard"
//                 style={{ margin: "10px", width: "40px", textAlign: "center" }}
//                 inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
//                 onChange={(e) => handleInputChange(e, index)}
//               />
//             ))}
//           </div>
//           <Button
//             variant="contained"
//             onClick={() => {
//               setVerifiedOpen(true);
//               setOpen(false);
//             }}
//           >
//             Verify
//           </Button>
//         </div>
//       </Dialog>

//       {/* Success Dialog */}
//       <Dialog open={verifiedOpen} onClose={() => setVerifiedOpen(false)}>
//         <div className="m-4 text-center">
//           <Successmsg />
//           <p>Verification Successful! Your Passport has been verified.</p>
//         </div>
//         <Button variant="contained" onClick={handleClose}>
//           Continue
//         </Button>
//       </Dialog>
//     </>
//   );
// };

export default VerifyPassport;
